import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/terms'
export default ($axios) => ({
  getTerms(params) {
    let resourceUrl = `${resource}`
    if (params.includeSignUpTerms) {
      resourceUrl += '/' + params.includeSignUpTerms
    }
    if (params.bundleId !== null) {
      resourceUrl += '/' + params.bundleId
    }
    return $axios.get(`${resourceUrl}/${params.includeGeneralTerms}/${params.includeShopTerms}/${params.includeBindingTerms}/${params.includeInstalmentTerms}`)
  }
})
